/*eslint-disable */

import {mapGetters, mapState} from 'vuex';

import assignmentDescription from '../../assignmentDescription/index';
import assignmentList from '@/components/assignmentlist/index';
import uploadsolution from '../uploadsolution/index';

var $ = window.jQuery = jQuery = require('jquery');



export default {
  name: 'assignment',
  components: {
    'upload-solution': uploadsolution,
    'assignment-description': assignmentDescription,
    'assignment-list': assignmentList
  }, 
  data () {
    return {
      showFormTemplate: false,
      assignmentList: {},
      singleAssignmentDescription: {}
    }
  },
  computed: {
    ...mapGetters([
      'getAssignmentList'
    ]),

    getAssignmentList(){
       this.assignmentList = this.$store.getters.getAssignmentList;
       return
    }

  },
  mounted () {
    this.getAssignmentList;
  },
  methods: {
    showBlogDescription: function(e){
      this.showFormTemplate = !this.showFormTemplate;
    },
    clickAssignment(id){
      this.showFormTemplate = false;
      this.$store.dispatch('getSignleAssignmentActn', {assignmentId: id}).then((res) => {
        
      }).catch((err) => {
       // console.log(err);
      })
    }
  },
  watch: {
    
    getAssignmentList(){
       
       return  this.$store.getters.getAssignmentList
    }
  },
   
}
